const getSizes = () => ({
  menuHeight: '84px',
  menuScrolledHeight: '52px',
})

export default getSizes
